module.exports = __webpack_public_path__ + "img/bsty1.57b36c00.jpg";